import DynamicFormState from "@bevco/Store/State/DynamicForm/DynamicFormState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: DynamicFormState = {
    fieldValues: {},
};

const reducer = {
    /** Clears all Dynamic Form field values. */
    "Components/DynamicForm/ClearForm": (draft: Draft<DynamicFormState>) => {
        draft.fieldValues = {};
    },
    /** Stores a Dynamic Form field value by Field Key. */
    "Components/DynamicForm/SetFieldValue": (
        draft: Draft<DynamicFormState>,
        action: { key: string; value: string },
    ) => {
        draft.fieldValues[action.key] = action.value;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
